import * as React from 'react';
const SvgLink = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            d="M7.075 8.449a1 1 0 01-1.63 1.158 4 4 0 01.434-5.142L8.886 1.46a4 4 0 115.657 5.657l-.707.707A1 1 0 1112.42 6.41l.707-.707a2 2 0 10-2.827-2.83L7.294 5.88a2 2 0 00-.22 2.57v-.001zm1.848-.901a1 1 0 111.627-1.164 4 4 0 01-.428 5.152L7.117 14.54a4.002 4.002 0 01-6.58-1.263 4 4 0 01.923-4.392l.707-.707A1 1 0 113.58 9.593l-.707.707a2 2 0 002.829 2.828l3.005-3.005a2 2 0 00.215-2.574v-.001z"
            fill="currentColor"
        />
    </svg>
);
export default SvgLink;
